<template>
  <div class="main-container">
    <!-- 固定头部信息 -->
    <div class="header-section">
      <div class="back">
        <button class="back-button" @click="handleBack">
          <i class="iconfont icon-fanhuiicon mr5"></i> 返回
        </button>
      </div>
    </div>
    <!-- 主要内容区域 -->
    <div class="content-wrapper">
      <h3 style="text-align: center; margin-bottom: 30px; font-size: 20px; font-weight: 600; color: #333;">{{ categoryInfo ? categoryInfo.categoryName : '-' }}申请</h3>
      <div class="content-steps">
        <!-- 步骤导航 -->
        <Steps :current="current" :style="{ marginBottom: '30px' }" @change="handleStepChange">
          <Step title="基本信息"/>
          <Step title="智能网联车辆"/>
          <Step title="驾驶员，安全员"/>
          <Step title="申请材料"/>
        </Steps>
      </div>

      <!-- 表单内容 -->
      <Form ref="formRef" layout="vertical">
        <!-- 第一步：基本信息 -->
        <div v-if="current === 0">

          <div class="info-area">
            <h3 class="area-title">测试日期</h3>
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">开始时间：</span>
                <DatePicker v-model:value="formData.startDate" placeholder="请选择开始时间" format="YYYY-MM-DD" value-format="YYYY-MM-DD" style="width: 200px;" />
              </div>
              <div class="info-item">
                <span class="info-label">有效期限：</span>
                <Select v-model:value="formData.months" placeholder="请选择有效期" style="width: 200px;">
                  <Option v-for="option in validityPeriodOptions" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </Option>
                </Select>
              </div>
            </div>
          </div>
          <div class="info-area">
            <h3 class="area-title">测试路线</h3>
            <Table
                :columns="testAreaColumns"
                :data-source="testAreaRoutes"
                :pagination="false">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'actions'">
                    <span>
                      <a-button style="padding: 0 5px"  class="action-btn" type="link" danger @click="handleDeletetestAreaRoute(record.key)">删除</a-button>
                    </span>
                </template>
              </template>
            </Table>
            <Button @click="handleAddTestingAreaRoute" type="dashed" style="width: 100%; margin: 10px 0; padding: 8px 5px; font-size: 16px; text-align: center; line-height: 24px;">
              + 添加测试路线
            </Button>
          </div>
        </div>

        <div v-if="current === 1">
          <!-- 测试车辆表格 -->
          <div class="info-area">
            <div class="area-header">
              <h3 class="area-title">智能网联车辆</h3>
              <Button type="primary" @click="handleSelectVehicle">选择车辆</Button>
            </div>
            <Table
                :columns="vehicleColumns"
                :data-source="testVehicleList"
                :pagination="false">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'productionDate'">
                  {{ record.productionDate ? formatDate(record.productionDate) : '' }}
                </template>
                <template v-if="column.key === 'type'">
                  {{ record.type ? testVehicleTypeList.find(item => item.id === record.type)?.name : '-' }}
                </template>
                <template v-if="column.key === 'actions'">
                <span>
                  <a-button style="padding: 0 5px" @click="openVehicleEditModal(record)" class="action-btn" type="link">编辑</a-button>
                  <a-button style="padding: 0 5px" @click="handleVehicleCopy(record)" class="action-btn" type="link">复制</a-button>
                  <a-button style="padding: 0 5px" @click="handleVehicleDelete(record)" class="action-btn" type="link" danger>删除</a-button>
                </span>
                </template>
              </template>
            </Table>
            <Button type="dashed" @click="openVehicleEditModal({})" style="width: 100%; margin: 10px 0; padding: 8px 5px; font-size: 16px; text-align: center; line-height: 24px;">
              + 添加车辆
            </Button>
          </div>
        </div>

        <!-- 第三步：驾驶员，安全员信息 -->
        <div v-if="current === 2">
          <div class="info-area">
            <h3 class="area-title">测试人员</h3>
            <div class="personnel-list">
              <div
                  v-for="record in testVehicleList"
                  :key="record.id"
                  class="personnel-card"
              >
                <!-- 头部车架号区域 -->
                <div class="frame-number-header">
                  <span class="frame-number-label">车辆识别代码:</span>
                  <span class="frame-number-value">{{ record.vin || '-' }}</span>
                </div>

                <!-- 主要信息区域 -->
                <div class="personnel-info-section">
                  <div
                          v-for="personnel in record.personnels || []"
                          :key="personnel.id"
                          class="personnel-list-card"
                      >
                    <div class="personnel-details-row">
                      <div class="detail-item type-item">
                        <span class="detail-label">类型：</span>
                        <span class="detail-value">{{ getPersonnelTypeName(personnel.type) }}</span>
                      </div>
                      <div class="detail-item name-item">
                        <span class="detail-label">姓名：</span>
                        <span class="detail-value">{{ personnel.name || '-' }}</span>
                      </div>
                      <div class="detail-item gender-item">
                        <span class="detail-label">性别：</span>
                        <span class="detail-value">{{ personnel.gender || '-' }}</span>
                      </div>
                      <div class="detail-item phone-item">
                        <span class="detail-label">联系方式：</span>
                        <span class="detail-value">{{ personnel.phone || '-' }}</span>
                      </div>
                      <div class="detail-item id-item">
                        <span class="detail-label">身份证号码：</span>
                        <span class="detail-value">{{ personnel.idCard || '-' }}</span>
                      </div>
                      <div class="detail-item date-item">
                        <span class="detail-label">培训日期：</span>
                        <span class="detail-value">{{ formatDate(personnel.trainingDate) || '-' }}</span>
                      </div>
                      <div class="detail-item actions-item">
                        <a-button @click="openPersonnelEditModal(personnel, record.id || record.key)" style="padding: 0 5px; margin-right: 10px;" class="action-btn" type="link">编辑</a-button>
                        <a-button @click="handlePersonnelDelete(personnel)" style="padding: 0 5px;" class="action-btn" type="link" danger>删除</a-button>
                      </div>
                    </div>
                  </div>
                  <Button type="dashed" @click="openPersonnelEditModal({}, record.id || record.key)" style="width: 100%; margin: 10px 0; padding: 8px 5px; font-size: 16px; text-align: center; line-height: 24px;">
                    + 添加驾驶员，安全员
                  </Button>
                </div>

              </div>
            </div>
          </div>
        </div>
        <!-- 第三步：申请材料提交 -->
        <div v-else-if="current === 3">
          <div class="info-area">
            <!-- 材料列表 -->
            <div v-for="item in applicationMaterialList" :key="item.id" class="document-item">
              <div class="document-header">
                <div class="document-title">
                  <span>{{ item.materialCode }}. {{ item.materialTitle }}</span>
                </div>
                <Button v-if="item.templateUrl" type="link" @click="downloadTemplate(item.materialId)">下载</Button>
              </div>
              <div class="document-upload">
                <MaterialFileManager
                    :materialId="item.materialId"
                    :initialFiles="item.files || []"
                    :supportedFormats="item.supportedFormats || []"
                    @update:files="(materialId, files) => handleFilesUpdate(materialId, files)"
                    @upload-success="handleUploadSuccess"
                    @delete="handleFileDelete"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="current === 3">
          <div class="notice-container">
            <h3 class="notice-title">{{ categoryInfo?.readingFileName || '申请须知' }}</h3>
            <div class="notice-content">
              <ol class="notice-list">
                <li class="notice-item">
                  本单位已详细审阅、理解、知悉<a :href="categoryInfo?.readingFileUrl || '#'" class="policy-link" target="_blank">{{ categoryInfo?.readingFileName || '《甘肃省智能网联汽车道路测试与示范应用管理实施细则（试行）》' }}</a>及相关材料内容，承诺接受所有条款约束，如有违反，自愿承担有关责任。
                </li>
                <li class="notice-item">
                  本单位提交的所有材料真实、有效、合法，若有不符，自愿承担相应法律责任。
                </li>
              </ol>
            </div>
            <div class="notice-agreement">
              <Checkbox v-model="agreedToNotice" @change="handleNoticeAgree">
                我已阅读并同意上述申请须知内容
              </Checkbox>
            </div>
          </div>
        </div>
        <!-- 操作按钮 -->
        <div class="form-actions">
          <Button v-if="current > 0" @click="prev" style="margin-right: 8px;">
            上一步
          </Button>
          <Button v-if="current < 3" type="primary" style="margin-right: 8px;" @click="next">
            下一步
          </Button>
          <Button v-if="current === 3" type="primary" style="margin-right: 8px;" @click="handleSave">
            保存
          </Button>
          <Button v-if="current === 3" type="primary" @click="handleSubmit">
            提交申请
          </Button>
        </div>
      </Form>
    </div>
    <!-- 测试区域选择弹框 -->
    <OpenAreaSelectModel
        v-model:visible="testAreaRouteModalVisible"
        v-model:category-code="categoryCode"
        :selected-routes="testAreaRoutes"
        @confirm="handleTestingAreaRouteSelect"

    />
    <VehicleEditModal
        :visible="vehicleEditModalVisible"
        :vehicle-type-list="testVehicleTypeList"
        :vehicle="selectedVehicle"
        :is-edit="true"
        @update:visible="(value) => vehicleEditModalVisible = value"
        @save="handleVehicleSave"
    />

    <PersonnelEditModal
        :visible="personnelEditModalVisible"
        :personnel="selectedPersonnel"
        :is-edit="true"
        @update:visible="(value) => personnelEditModalVisible = value"
        @save="handlePersonnelSave"
    />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from 'vue';
import { message } from 'ant-design-vue';
import { Steps, Form, Button, Select, DatePicker, Table, Checkbox } from 'ant-design-vue';
import { useRouter, useRoute } from 'vue-router';
import MaterialFileManager from '@/components/MaterialFileManager/index.vue';
import { getCategory } from '@/api/settings/category';
import { getVehicleTypeList } from "@/api/settings/vehicleType";
import { getApplicationMaterialsByCategory } from '@/api/settings/applicationMaterials';
import { testApplication, getTestApplication } from '@/api/application/testApplication';

import OpenAreaSelectModel from '../components/OpenAreaSelectModel.vue';
import VehicleEditModal from './components/VehicleEditModal.vue';
import PersonnelEditModal from './components/PersonnelEditModal.vue';

// 获取人员类型的中文名称
const getPersonnelTypeName = (type) => {
  const typeMap = {
    'driver': '驾驶员',
    'security': '安全员'
  };
  return typeMap[type] || type || '-';
};


const router = useRouter();
const route = useRoute();

const { Step } = Steps;
const { Option } = Select;

// 获取路由参数中的type值和code值
const categoryId = ref('');
const categoryType = ref(route.query.type || '');
const categoryCode = ref(route.query.code || '');
const categoryInfo = ref(null);

const applicationId = ref(route.query.id || '');

// 当前步骤
const current = ref(0);
// 表单引用
const formRef = ref();
// 是否同意申请须知
const agreedToNotice = ref(false);

// 返回
const handleBack = () => {
  router.push('/application/index');
};

// 有效期选项
const validityPeriodOptions = [
  { value: 1, label: '1个月' },
  { value: 3, label: '3个月' },
  { value: 6, label: '6个月' }
];

// 表单数据
const formData = reactive({
  id: '',
  categoryId: categoryId.value,
  categoryType: categoryType.value,
  categoryCode: categoryCode.value,
  startDate: '',
  months: null,
  endDate: '',
  status: 0,
  testAreaRoutes: [],
  testVehicleList: [],
  testPersonnelList: [],
  applicationMaterialList: [],
});

// 测试路线数据=================================================
const testAreaRoutes = ref(formData.testAreaRoutes);

// 测试路线表格列配置
const testAreaColumns = [
  {
    title: '测试区域',
    dataIndex: 'areaName',
    key: 'areaName'
  },
  {
    title: '测试路线',
    dataIndex: 'routeName',
    key: 'routeName'
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: 160
  }
];


// 测试区域选择弹框控制
const testAreaRouteModalVisible = ref(false);

// 打开测试区域选择弹框
const handleAddTestingAreaRoute = () => {
  testAreaRouteModalVisible.value = true;
};

// 处理测试区域选择结果
const handleTestingAreaRouteSelect = (selectedData) => {
  // 处理多选后的routes数组
  if (selectedData && selectedData.routes && selectedData.routes.length > 0) {
    // 遍历所有选中的路线
    selectedData.routes.forEach(route => {
      // 为每条路线创建新的数据项
      const newRoute = {
        key: route.routeId, // 确保key唯一性
        areaId: route.areaId || selectedData.areaId,
        areaName: route.areaName || selectedData.areaName,
        routeId: route.routeId,
        routeName: route.name,
      };

      // 检查是否已存在相同的路线
      const exists = testAreaRoutes.value.some(item => item.routeId === newRoute.routeId);
      if (!exists) {
        testAreaRoutes.value.push(newRoute);
      }
    });
  }
  testAreaRouteModalVisible.value = false;
};

// 删除测试路线
const handleDeletetestAreaRoute = (key) => {
  const index = testAreaRoutes.value.findIndex(item => item.key === key);
  if (index !== -1) {
    testAreaRoutes.value.splice(index, 1);
  }
};

// 测试车辆数据=================================================
const testVehicleList = ref([]);
const testVehicleTypeList = ref([]);

// 确保车辆数据中包含personnels数组
const ensurePersonnelsArray = () => {
  testVehicleList.value.forEach(vehicle => {
    if (!vehicle.personnels) {
      vehicle.personnels = [];
    }
  });
};

// 测试车辆表格列定义
const vehicleColumns = [
  {
    title: '车辆识别代码',
    dataIndex: 'vin',
    key: 'vin',
    width: 160
  },
  {
    title: '车辆型号',
    dataIndex: 'model',
    key: 'model',
    width: 100
  },
  {
    title: '车辆种类',
    dataIndex: 'type',
    key: 'type',
    width: 120
  },
  {
    title: '车辆颜色',
    dataIndex: 'color',
    key: 'color',
    width: 90
  },
  {
    title: '动力形式',
    dataIndex: 'powerType',
    key: 'powerType',
    width: 90
  },
  {
    title: '生产企业',
    dataIndex: 'manufacturer',
    key: 'manufacturer',
    width: 180
  },
  {
    title: '生产日期',
    dataIndex: 'productionDate',
    key: 'productionDate',
    width: 90
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: 150
  }
];

const selectedVehicle = ref({});
// 车辆编辑弹框相关
const vehicleEditModalVisible = ref(false);

// 初始化车辆数据，为没有id的项添加id，并确保有personnels数组
const initializetestVehicleList = () => {
  testVehicleList.value.forEach((vehicle, index) => {
    if (!vehicle.id) {
      testVehicleList.value[index].id = generateUniqueId();
    }
    // 确保personnels数组存在
    if (!vehicle.personnels) {
      testVehicleList.value[index].personnels = [];
    }
  });
};

// 打开车辆编辑弹框
const openVehicleEditModal = (vehicle) => {
  // 如果是新数据或没有id，生成唯一id
  if (!vehicle || !vehicle.id) {
    selectedVehicle.value = { ...vehicle, id: generateUniqueId() };
  } else {
    selectedVehicle.value = { ...vehicle };
  }
  vehicleEditModalVisible.value = true;
};

// 删除车辆
const handleVehicleDelete = (record) => {
  if (record.id) {
    // 优先使用id查找
    const index = testVehicleList.value.findIndex(item => item.id === record.id);
    if (index !== -1) {
      testVehicleList.value.splice(index, 1);
    }
  }
};

// 复制车辆数据
const handleVehicleCopy = (record) => {
  // 复制当前记录的数据
  const copiedData = { ...record };
  
  // 清除id和vin字段，以便保存为新记录
  delete copiedData.id;
  copiedData.personnels = []
  copiedData.vin = '';
  
  // 打开编辑弹框，让用户可以修改并保存为新记录
  openVehicleEditModal(copiedData);
};

// 选择车辆
const handleSelectVehicle = () => {
  // 这里可以实现选择车辆的逻辑
  console.log('选择车辆');
};

// 生成唯一ID的辅助函数
const generateUniqueId = () => {
  // 生成纯数字类型的字符串ID
  return Date.now().toString() + Math.floor(Math.random() * 1000);
};

const handleVehicleSave = (vehicle) => {
  // 解构获取所需信息
  const { isEdit, originalVin, ...vehicleInfo } = vehicle;
  
  // 编辑模式下，检查vin是否变更
  if (isEdit && originalVin && originalVin !== vehicleInfo.vin) {
    // 检查新的vin是否已存在于其他车辆记录中
    const vinExists = testVehicleList.value.some(item => 
      item.vin === vehicleInfo.vin && (!vehicleInfo.id || item.id !== vehicleInfo.id)
    );
    
    if (vinExists) {
      message.warning(`车辆识别代码已存在${vehicleInfo.vin}，无法更新`);
      return; // 不更新数据并退出
    }
  }
  
  // 如果有id字段，优先使用id进行匹配更新
  if (vehicleInfo.id) {
    const index = testVehicleList.value.findIndex(item => item.id === vehicleInfo.id);
    if (index !== -1) {
      testVehicleList.value[index] = vehicleInfo;
      return;
    }
  }
  
  // 对于新数据，添加唯一id
  if (!vehicleInfo.id) {
    vehicleInfo.id = generateUniqueId();
  }
  
  // 如果是编辑模式且没有id但vin相同，直接保存
  if (isEdit && originalVin === vehicleInfo.vin) {
    // 查找并更新现有数据
    const index = testVehicleList.value.findIndex(item => item.vin === originalVin);
    if (index !== -1) {
      testVehicleList.value[index] = vehicleInfo;
    } else {
      testVehicleList.value.push(vehicleInfo);
    }
    return;
  }
  
  // 其他情况检查是否已存在相同的识别码（不包括当前正在编辑的记录）
  const exists = testVehicleList.value.some(item => 
    item.vin === vehicleInfo.vin && (!vehicleInfo.id || item.id !== vehicleInfo.id)
  );
  
  if (exists) {
    message.warning(`车辆识别代码已存在${vehicleInfo.vin}`);
  } else {
    testVehicleList.value.push(vehicleInfo);
  }
}

//测试人员信息===================================================
const testPersonnelList = ref();

// 移除独立的personnelData，人员数据现在存储在testVehicleList的personnels数组中
const selectedPersonnel = ref({});
const personnelEditModalVisible = ref(false);

// 当前选中的车辆ID
const currentVehicleId = ref('');

const openPersonnelEditModal = (personnel, vehicleId = '') => {
  // 新增时不生成ID，等到保存时再生成
  selectedPersonnel.value = { ...personnel };
  currentVehicleId.value = vehicleId;
  personnelEditModalVisible.value = true;
};

const handlePersonnelSave = (personnelInfo) => {
  console.log("save personnelInfo", personnelInfo);
  if (currentVehicleId.value) {
    const vehicle = testVehicleList.value.find(v => v.id === currentVehicleId.value || v.key === currentVehicleId.value);
    if (vehicle) {
      if (!vehicle.personnels) {
        vehicle.personnels = [];
      }
      
      if (personnelInfo.id) {
        // 编辑模式，查找并更新该车辆下的人员
        const index = vehicle.personnels.findIndex(p => p.id === personnelInfo.id);
        if (index !== -1) {
          vehicle.personnels[index] = personnelInfo;
        }
      } else {
        // 新增模式，添加到该车辆的人员列表中
        const newPersonnel = { ...personnelInfo, id: generateUniqueId() };
        vehicle.personnels.push(newPersonnel);
      }
    } else {
      message.error('未找到对应的车辆信息');
    }
  } else {
    message.error('请先选择车辆');
  }
};

const handlePersonnelDelete = (personnel) => {
  // 在所有车辆中查找并删除该人员
  let deleted = false;
  testVehicleList.value.forEach(vehicle => {
    if (vehicle.personnels) {
      const index = vehicle.personnels.findIndex(p => p.id === personnel.id);
      if (index !== -1) {
        vehicle.personnels.splice(index, 1);
        deleted = true;
      }
    }
  });

  if (!deleted) {
    message.error('未找到要删除的人员信息');
  }
};

// 申请材料列表=================================================
const applicationMaterialList = ref();

// 下载模板
const downloadTemplate = (materialId) => {
  // 模拟下载模板的逻辑
  message.success('模板下载成功！');
};

// 处理文件列表更新
const handleFilesUpdate = (materialId, files) => {
  console.log('文件列表已更新:', files.length, '材料ID:', materialId);
  //const material = applicationMaterialList?.value?.find(item => item.materialId === materialId);
  // if (material) {
  //   material.files = files;
  // }
};

// 处理文件上传成功
const handleUploadSuccess = (file, materialId) => {
  console.log('文件上传成功:', file.name, '材料ID:', materialId);
  // 在文件上传成功后，查找对应的材料并更新其files属性
  const material = applicationMaterialList?.value?.find(item => item.materialId === materialId);
  if (material) {
    // 确保files是数组
    if (!Array.isArray(material.files)) {
      material.files = [];
    }
    // 检查是否已存在相同uid的文件，如果不存在则添加
    const existingFileIndex = material.files.findIndex(f => f.uid === file.uid);
    if (existingFileIndex === -1) {
      material.files.push(file);
    } else {
      // 如果文件已存在，则更新它
      material.files[existingFileIndex] = file;
    }
    // 按文件名排序
    material.files.sort((a, b) => a.name.localeCompare(b.name, 'zh-CN'));
    console.info(material.files, "material.files after upload");
    console.info(applicationMaterialList.value, "applicationMaterialList after upload");
  }
};

// 处理文件删除
const handleFileDelete = (file, materialId) => {
  console.log('文件删除:', file.name, '材料ID:', materialId);
  // 在文件删除后，查找对应的材料并更新其files属性
  const material = applicationMaterialList?.value?.find(item => item.materialId === materialId);
  if (material && Array.isArray(material.files)) {
    // 过滤掉要删除的文件
    material.files = material.files.filter(f => f.uid !== file.uid);
    console.info(material.files, "material.files after delete");
  }
};

// 下一步
const next = () => {
  // 表单验证
  if (current.value < 3) {
    current.value++;
  }
};

// 处理步骤点击切换
const handleStepChange = (currentStep) => {
  // 可以在这里添加验证逻辑，控制是否允许跳转到特定步骤
  current.value = currentStep;
};

// 上一步
const prev = () => {
  if (current.value > 0) {
    current.value--;
  }
};

// 处理同意申请须知
const handleNoticeAgree = (e) => {
  agreedToNotice.value = e.target.checked;
};

const handleSave = () => {

  formatFormData()
  formData.status = 0;
  console.log('保存的数据:', formData);

  // 这里可以添加API调用逻辑
  testApplication(formData).then(res =>{
    if (res.code === 200 && res.data){
      message.success('道路测试保存成功！');
      formData.id = res.data
    }
  })
}

// 提交申请
const handleSubmit = () => {
  // 验证是否同意申请须知
  if (current.value === 3 && !agreedToNotice.value) {
    message.warning('请阅读并同意申请须知内容');
    return;
  }
  formatFormData()
  formData.status = 1;
  console.log('提交数据:', formData);

  // 这里可以添加API调用逻辑
  testApplication(formData).then(res =>{
    if (res.code === 200 && res.data){
      message.success('道路测试申请提交成功！');
      formData.id = res.data;
      router.push("/application/index");
    }
  })
};

const formatFormData = () => {
  //将测试车辆与测试人员的信息格式化
  const vehicleList = testVehicleList.value
  // 遍历车辆中的人员信息，添加对应车辆的vin值，组成新的数据列表
  const personnelDataList = [];
  vehicleList.forEach(v => {
    const personnels = v.personnels;
    const vehicleVin = v.vin; // 获取车辆的vin值
    if (personnels && Array.isArray(personnels)) {
      personnels.forEach(p => {
        // 为每个人员对象添加vin属性，创建新对象避免修改原数据
        const personnelWithVin = { ...p, vin: vehicleVin };
        personnelDataList.push(personnelWithVin);
      });
    }
  });

  formData.testAreaRoutes  = testAreaRoutes.value
  formData.testVehicleList = vehicleList;
  // 将新的数据列表赋值给testPersonnelList
  formData.testPersonnelList = personnelDataList;
  formData.applicationMaterialList = applicationMaterialList.value;
}

// 根据ID获取申请信息
const fetchApplicationData = async (id) => {
  if (!id) return;

  try {
    const response = await getTestApplication(id);
    if (response.code === 200 && response.data) {
      const data = response.data;

      // 填充表单数据
      formData.id = data.id || '';
      formData.categoryId = data.categoryId || '';
      formData.categoryType = data.categoryType || '';
      formData.categoryCode = data.categoryCode || '';
      formData.startDate = data.startDate || '';
      formData.months = data.months || null;
      formData.endDate = data.endDate || '';
      formData.status = data.status || 0;

      // 更新测试路线
      if (data.testAreaRoutes && Array.isArray(data.testAreaRoutes)) {
        testAreaRoutes.value = data.testAreaRoutes.map(route => ({
          ...route
        }));
      }

      // 更新测试人员列表
      if (data.testPersonnelList && Array.isArray(data.testPersonnelList)) {
        testPersonnelList.value = data.testPersonnelList.map(personnel => ({
          ...personnel
        }));
      }

      // 更新测试车辆列表，并从testPersonnelList中匹配对应的人员信息
      if (data.testVehicleList && Array.isArray(data.testVehicleList)) {
        testVehicleList.value = data.testVehicleList.map(vehicle => ({
          ...vehicle,
          id: vehicle.id,
          personnels: (data.testPersonnelList && Array.isArray(data.testPersonnelList)) 
            ? data.testPersonnelList.filter(p => p.vin === vehicle.vin).map(p => ({ ...p })) 
            : []
        }));
      }

      // 更新申请材料列表
      if (data.applicationMaterialList && Array.isArray(data.applicationMaterialList)) {
        applicationMaterialList.value = data.applicationMaterialList;
      }
    }
  } catch (error) {
    console.error('获取申请信息失败:', error);
    message.error('加载申请信息失败，请重试');
  }
};

// 查询测试分类信息
const fetchCategoryInfo = async () => {
  try {
    if (!categoryType.value || !categoryCode.value) {
      console.warn('缺少必要的路由参数');
      return;
    }
    const response = await getCategory(categoryType.value, categoryCode.value);
    if (response.code === 200 && response.data) {
      categoryInfo.value = response.data;
    } else {
      message.error('获取分类信息失败');
    }
  } catch (error) {
    console.error('查询分类信息时出错:', error);
  }
};

//获取测试申请材料列表
const fetchApplicationMaterials = async () => {
  try {
    if (!categoryCode.value) {
      console.warn('缺少必要的路由参数');
      return;
    }
    const response = await getApplicationMaterialsByCategory(categoryCode.value);
    if (response.code === 200 && response.data) {
      applicationMaterialList.value = response.data;
    } else {
      message.error('获取测试申请材料列表失败');
    }
  } catch (error) {
    console.error('查询测试申请材料列表时出错:', error);
  }
};

const fetchVehicleTypeList = async () => {

  try {
    if (!categoryCode.value) {
      console.warn('缺少必要的路由参数');
      return;
    }
    let params = {
      categoryType: categoryType.value
    };
    const response = await getVehicleTypeList(params);
    if (response.code === 200 && response.data) {
      testVehicleTypeList.value = response.data;
    } else {
      message.error('获取车辆类型列表失败');
    }
  } catch (error) {
    console.error('查询车辆类型列表时出错:', error);
  }
}

// 格式化日期为年月日格式
const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    const Y = date.getFullYear();
    const M = String(date.getMonth() + 1).padStart(2, '0');
    const D = String(date.getDate()).padStart(2, '0');
    return `${Y}-${M}-${D}`;
  } catch (error) {
    return dateString;
  }
};

// 监听categoryInfo变化，更新categoryId
watch(() => categoryInfo.value?.id, (newId) => {
  categoryId.value = newId || '';
}, { immediate: true });

onMounted(() => {
  fetchCategoryInfo();
  fetchApplicationMaterials();
  fetchVehicleTypeList();
});

// 在组件挂载时初始化车辆数据
onMounted(() => {
  initializetestVehicleList();
  ensurePersonnelsArray();
});

// 监听applicationId变化，加载对应申请信息
watch(() => applicationId.value, (newId) => {
  if (newId) {
    fetchApplicationData(newId);
  }
}, { immediate: true });

</script>

<style scoped lang="less">
.main-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  overflow: hidden;
}

.header-section {
  flex-shrink: 0;
  padding: 12px 12px 0 12px;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  z-index: 10;
}

.info-area {
  margin-bottom: 20px;
  padding: 10px 12px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background-color: #ffffff;
}

.area-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9d9d9;
  margin-bottom: 16px;
}

.area-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.info-label {
  width: 100px;
  font-size: 15px;
  color: #666;
  flex-shrink: 0;
}

.info-value {
  flex: 1;
  color: #333;
  word-break: break-all;
  font-size: 15px;
}

.back {
  position: fixed;
  top: 93px;
  right: 50px;
  z-index: 20;
}

.back-button {
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.back-button:hover {
  background-color: #40a9ff;
}

.back-button:active {
  background-color: #096dd9;
}

.content-wrapper {
  flex: 1;
  overflow-y: auto;
  padding: 40px;
  margin: 0 auto;
  width: 100%;
}

// 人员列表相关样式
.personnel-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.personnel-card {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.personnel-list-card {
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 7px;
  margin-bottom: 7px;
}

.personnel-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

// 车架号头部区域
.frame-number-header {
  background-color: #fafafa;
  padding: 12px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
}

.frame-number-label {
  font-size: 14px;
  color: #666;
  margin-right: 8px;
}

.frame-number-value {
  font-size: 16px;
  font-weight: 400;
  color: #333;
}

// 人员信息区域
.personnel-info-section {
  padding: 12px;
}

.personnel-details-row {
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: nowrap;
  gap: 15px;
}

.detail-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
}

.detail-label {
  color: #666;
  font-size: 14px;
}

.detail-value {
  color: #333;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
}

// 不同项目的宽度设置
.name-item {
  flex: 0 0 auto;
  min-width: 120px;
}

.gender-item {
  flex: 0 0 auto;
  min-width: 100px;
}

.phone-item {
  flex: 0 0 auto;
  min-width: 180px;
}

.id-item {
  flex: 0 0 auto;
  min-width: 280px;
}

.type-item {
  flex: 0 0 auto;
  min-width: 100px;
}

.date-item {
  flex: 0 0 auto;
  min-width: 140px;
}

.actions-item {
  display: flex;
  white-space: nowrap;
  margin-left: auto !important;
  min-width: 120px;
  justify-content: flex-end;
}

// 操作按钮区域
.action-section {
  padding: 12px;
  border-top: 1px solid #e8e8e8;
  background-color: #fafafa;
  display: flex;
  justify-content: flex-end;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 材料列表样式 */
.document-item {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #fafafa;
}

.document-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.document-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 14px;
}

.document-description {
  color: #666;
  margin-bottom: 12px;
  font-size: 14px;
}

.document-upload {
  margin-top: 10px;
}

.content-steps {
  padding-left: 200px;
  padding-right: 200px;
}

.notice-container {
  //background: #f7f9fc;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px 24px ;
  margin: 10px 0;
}

.notice-title {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 16px;
  text-align: center;
}

.notice-content {
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 20px;
  line-height: 1.6;
}

.notice-list {
  padding-left: 24px;
  margin: 0;
}

.notice-item {
  color: #595959;
  margin-bottom: 16px;
  text-align: justify;
}

.policy-link {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s;
}

.policy-link:hover {
  color: #40a9ff;
  text-decoration: underline;
}

.notice-item:last-child {
  margin-bottom: 0;
}

.notice-agreement {
  text-align: center;
  margin-top: 24px;
}

.notice-agreement :deep(.ant-checkbox-wrapper) {
  font-size: 14px;
  color: #595959;
}

.form-actions {
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
}

:deep(.ant-card) {
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

// 自定义滚动条样式
.content-wrapper::-webkit-scrollbar {
  width: 6px;
}

.content-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.content-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.content-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

// 减小表格空状态的边距
:deep(.ant-empty-normal) {
  margin: 0 0;
}

:deep(.ant-table-cell) {
  padding: 8px 23px !important;
}

// 响应式设计
@media (max-width: 768px) {
  .content-wrapper {
    padding: 16px;
  }

  .back {
    position: relative;
    top: 0;
    right: 0;
    margin-bottom: 20px;
  }
}
</style>